(function () {
  var wlyScript = document.currentScript || document.querySelector('script[data-wly-chat-privacy]');
  if (!wlyScript) return;
  var wlyColor = wlyScript.getAttribute('data-wly-chat-privacy');
  if (!wlyColor) return;
  var wlyCss = '#self-service-portal-container [data-testid="privacy-notice-trigger"]{color:' + wlyColor + ' !important}';
  function wlyStyle(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (e) { return; }
    if (!doc || !doc.head || doc.getElementById('wly-chat-style')) return;
    var tag = doc.createElement('style');
    tag.id = 'wly-chat-style';
    tag.textContent = wlyCss;
    doc.head.appendChild(tag);
  }
  function wlyCheck() {
    var frame = document.getElementById('chat-window');
    if (!frame) return;
    wlyStyle(frame);
    if (!frame.wlyBound) {
      frame.wlyBound = true;
      frame.addEventListener('load', function () { wlyStyle(frame); });
    }
  }
  function wlyStart() {
    wlyCheck();
    if (!window.MutationObserver) return;
    new MutationObserver(wlyCheck).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wlyStart);
  else wlyStart();
})();
